export default __webpack_public_path__ + "static/media/pencil.dd1dd099.svg";